module.exports = __webpack_public_path__ + "static/media/foto3.667df47b.png";